// Card component with div styled
import { styled } from '@mui/material/styles';
var Container = styled('div')(function (_a) {
    var theme = _a.theme, width = _a.width, height = _a.height, justifyContent = _a.justifyContent, alignItems = _a.alignItems, direction = _a.direction;
    return ({
        display: 'flex',
        flexDirection: direction || 'column',
        alignSelf: 'center',
        width: width || '100%',
        height: height || 'auto',
        boxSizing: 'border-box',
        justifyContent: justifyContent || 'center',
        alignItems: alignItems || 'center',
        // padding: theme.spacing(4),
        gap: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
    });
});
export default Container;
